const closePasswordSheet = (dialog, animated = true) => {
  if (!dialog?.open || dialog.dataset.passwordSheetClosing === 'true') return;
  dialog.dataset.passwordSheetClosing = 'true';
  dialog.style.setProperty('--password-sheet-y', '100svh');
  const delay = animated && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 250 : 0;
  window.setTimeout(() => dialog.close(), delay);
};

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-password-information-open]');
  if (openButton) {
    const dialog = document.getElementById(openButton.dataset.passwordInformationOpen);
    if (dialog) {
      delete dialog.dataset.passwordSheetClosing;
      dialog.style.setProperty('--password-sheet-y', '0px');
      dialog.showModal();
    }
    return;
  }

  const handle = event.target.closest('[data-password-sheet-handle]');
  if (handle && !handle.dataset.passwordSheetDragged) closePasswordSheet(handle.closest('dialog'));
});

document.addEventListener('click', (event) => {
  const dialog = event.target.closest('dialog.password-information, dialog.instructions-page-dialog');
  if (dialog && event.target === dialog) closePasswordSheet(dialog);
});

document.addEventListener('pointerdown', (event) => {
  const handle = event.target.closest('[data-password-sheet-handle]');
  if (!handle || event.button !== 0) return;
  const dialog = handle.closest('dialog');
  if (!dialog?.open || dialog.dataset.passwordSheetClosing === 'true') return;

  const pointerId = event.pointerId;
  const startY = event.clientY;
  let dragY = 0;
  event.preventDefault();
  dialog.classList.add('is-dragging');
  handle.setPointerCapture(pointerId);

  const move = (moveEvent) => {
    if (moveEvent.pointerId !== pointerId) return;
    dragY = Math.max(0, moveEvent.clientY - startY);
    dialog.style.setProperty('--password-sheet-y', `${dragY}px`);
  };
  const finish = (finishEvent) => {
    if (finishEvent.pointerId !== pointerId) return;
    window.removeEventListener('pointermove', move);
    window.removeEventListener('pointerup', finish);
    window.removeEventListener('pointercancel', finish);
    dialog.classList.remove('is-dragging');
    handle.dataset.passwordSheetDragged = dragY > 8 ? 'true' : '';
    if (dragY >= Math.max(72, window.innerHeight * .12)) closePasswordSheet(dialog);
    else dialog.style.setProperty('--password-sheet-y', '0px');
    window.setTimeout(() => delete handle.dataset.passwordSheetDragged, 0);
  };
  window.addEventListener('pointermove', move);
  window.addEventListener('pointerup', finish);
  window.addEventListener('pointercancel', finish);
});

document.addEventListener('close', (event) => {
  if (!event.target.matches?.('dialog.password-information, dialog.instructions-page-dialog')) return;
  delete event.target.dataset.passwordSheetClosing;
  event.target.classList.remove('is-dragging');
  event.target.style.setProperty('--password-sheet-y', '0px');
}, true);
